module.exports = __webpack_public_path__ + "static/media/shoubao.b22be4d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/shoubao.mp3
// module id = nOux
// module chunks = 208